/*
* Earned Certificates Front End
*
*/

const ECFront = ($) => {

  if (!window.Tangible) return

  //console.log(window.Tangible)

  const tangibleSelect = window.Tangible.Select;
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig
  const ajaxurl = tgblCeuFrontend.ajaxurl

  // Global object
  window.eC= {}

  $(document).ready(function () {
    window.eC.ECFront.constructor()
  })

  window.eC.ECFront = {

    // initialize the code
    constructor: function () {
      this.select2OnChange()
      this.select2Search()
      this.toggleCeusList()
    },


    toggleCeusList: function () {
      const button = $('.ceus-list-button')
      const collapsible = button.parents('.ceus-list-wrap').find('.ceus-list-collapsible')

      button.on('click', function(e){
        e.preventDefault()
        const $this=$(this)
        if($this.hasClass('collapsed')){
          collapsible.slideDown()
          $this.removeClass('collapsed')

        }else{
          collapsible.slideUp()
          $this.addClass('collapsed')
        }
      })

    },


    select2Search: function () {
      // Region
      $('.tgbl-select-region-front').tangibleSelect()
    },


    select2OnChange: function () {
      $('.tgbl-select-region-front').on('change', function (e) {

        const parent = $(this).parents('.certificate-choose-region-wrap')
        const user_id = parent.data('user_id')
        const course_id = parent.data('course_id')
        const date_format = parent.data('date_format')

        const data = {
          code : $(this).val(),
          text : $(this).find('option:selected').text(),
          user_id : user_id,
          course_id : course_id,
          date_format : date_format,
        }

        const response = parent.find('.certificate-region-choice-response');
        response.find('.error').html('')
        response.find('.success').html('')
        response.removeClass('active')

        // ajax get certificates

        ajax('tgbl_user_ceu_certificates_ajax', data)
          .then(function(res) {

            //console.log('RESPONSE --- ',  res) // RESPONSE ---  false
            if(res === false){
              response.find('.error').html(tgblCeuFrontend.localized.certs_not_found)
              response.addClass('active')

            } else if(res){
              response.find('.success').html(res)
              response.addClass('active')
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
            response.find('.error').html(tgblCeuFrontend.localized.certs_wrong)
            response.addClass('active')
          }) // end ajax

      })
    },
  }
}
export {ECFront}
